import { useMemo, useCallback } from 'react'
import { useAtom } from 'jotai'
import { safeSearchAtom } from '@!/atoms/safeSearchAtom'

const allTabs = [
  { name: 'total', label: '総合', safeSearchable: true },
  { name: 'boy', label: '少年', safeSearchable: true },
  { name: 'man', label: '青年', safeSearchable: true },
  { name: 'girl', label: '少女', safeSearchable: true },
  { name: 'lady', label: '女性', safeSearchable: true },
  { name: 'media', label: 'メディア化', safeSearchable: true },
  { name: 'amazia', label: 'オリジナル', safeSearchable: true },
]

export const useTabs = (tabName) => {
  const [safeSearch] = useAtom(safeSearchAtom)
  const filteredTabs = useMemo(() => (safeSearch ? allTabs.filter((tab) => tab.safeSearchable) : allTabs), [safeSearch])
  const tab = useMemo(() => filteredTabs.find((tab) => tab.name === tabName) || filteredTabs[0], [tabName, filteredTabs])

  const currentTab = useMemo(() => {
    const index = filteredTabs.findIndex((t) => t.name === tab.name)
    return {
      ...tab,
      index,
    }
  }, [tab, filteredTabs])

  const handleTabChange = useCallback(
    (index) => {
      const { name } = filteredTabs[index]
      if (name === 'total') {
        window.location.href = '/store/rankings'
      } else {
        window.location.href = `/store/rankings?ranking_type=${name}`
      }
    },
    [filteredTabs],
  )

  return { currentTab, tabs: filteredTabs, handleTabChange }
}
